import '../layouts/ansysoft.css';
import rightArrow from '../assets/right-arrow.svg'
import { Link } from 'react-router-dom';

function BusinessPlan() {
    return (
        <>
            <div className="w-100 plan-bg">
                <div className="container plan-wrap">
                    <div className="plan">
                        <h1 className="subheading-1-business">PROMETA TECHNOVERSE</h1>
                        <h1 className="heading-1 mt-4">ACHEIVEMENTS</h1>
                        <p className="description-1 mt-3 mt-md-5">
                            1. Sponsoring bonus<br />
                            2. Auto booster (Optional)<br />
                            3. Leadership bonus (Level Income)<br />
                            4. Rank Upgradation Bonus<br />
                            5. Global Auto Pool<br />
                            6. Additional term bonus or Surprise bonus<br />
                        </p>
                        <Link to="/signin" className="btn-main scnd-width businessplan-width btn-outline-main background-black">
                            READ MORE 
                            <img src={rightArrow} alt="===>" width="36" height="100%" />
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BusinessPlan;